import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m16.4 14.136-.936-.936H3.6V3.6h12.8v10.536ZM16.4 2H3.6C2.72 2 2 2.72 2 3.6v9.6c0 .88.72 1.6 1.6 1.6h11.2L18 18V3.6c0-.88-.72-1.6-1.6-1.6Z",
  fill: "#D5D4D6"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }